module.exports = __webpack_public_path__ + "media/images/red_heart-e553e910cf864ce6871afa188dbf4fe8.svg";